// extracted by mini-css-extract-plugin
export var button = "_51-7";
export var buttonRow = "_51-6";
export var fadeIn = "_51-1";
export var gradient = "_51-0";
export var panel = "_51-2";
export var panelIn = "_51-3";
export var subtitle = "_51-5";
export var title = "_51-4";